
(function() {
  var module = {};
  var result = {};
  module.exports = { "zh-cn": { "i18n": { "duration": { "seconds": "{{ seconds }} 秒", "minutes": "{{ minutes }} 分钟", "hours": "{{ hours }} 小时", "hoursAndMinutes": "{{ hours }} 小时 {{ minutes }} 分钟", "days": "{{ days }} 天", "shortForm": { "seconds": "{{ seconds }} 秒", "minutes": "{{ minutes }} 分钟", "hours": "{{ hours }} 小时", "days": "{{ days }} 天", "hoursAndMinutes": "{{ hours }} 小时 {{ minutes }} 分钟" } }, "dateTime": { "shortForm": { "months": { "january": "1  月", "february": "2 月", "march": "3 月", "april": "4 月", "may": "5 月", "june": "6 月", "july": "7 月", "august": "8 月", "september": "9 月", "october": "10 月", "november": "11 月", "december": "12 月" } }, "monthAndDay": "{{monthName}} {{dayNumber}} 日", "monthAndYear": " {{yearNumber}} 年 {{monthName}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "I18n": {
    "zh-cn": "static-7.446"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "cs": "static-7.446",
    "da": "static-7.446",
    "de": "static-7.446",
    "el": "static-7.446",
    "en": "static-7.446",
    "es-mx": "static-7.446",
    "es": "static-7.446",
    "fi": "static-7.446",
    "fr": "static-7.446",
    "it": "static-7.446",
    "ja": "static-7.446",
    "ko": "static-7.446",
    "nl": "static-7.446",
    "no": "static-7.446",
    "pl": "static-7.446",
    "pt-br": "static-7.446",
    "sv": "static-7.446",
    "zh-cn": "static-7.446",
    "zh-hk": "static-7.446"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:zh-cn', {version: 'static-7.446'}); }
})();


